// Configuración central del modo claro/oscuro. Fuente de verdad única para el
// nombre de la cookie, el modo por defecto y la validación.

export type ThemeMode = "light" | "dark";

export const THEME_COOKIE = "theme";
export const DEFAULT_THEME: ThemeMode = "light";

/** Type guard para validar el valor (no confiable) de la cookie. */
export function isThemeMode(value: unknown): value is ThemeMode {
  return value === "light" || value === "dark";
}
